// Веб-вклад модуля `tutor` — AI-репетитор.
//
// Сквозная поверхность: пункт навигации у него есть, но главный вход —
// глобальная боковая панель, доступная с любого экрана. Три плитки воркспейса
// (mind map / инфографика / выжимка) собственной генерации не имеют — это
// тонкие обёртки над курсовым чатом, поэтому `kitKind` у них нет и дефолтное
// «добрать комплект» им не подходит: поведение задаёт клиентский слой.

import {
	IconChartInfographic,
	IconMessageCircle,
	IconSitemap,
	IconTextCaption,
} from "@tabler/icons-react";
import {
	SECTION_CATEGORY,
	SECTION_ICONS,
	SECTION_TINT,
} from "@/components/navigation/section-icons";
import type { WebModuleManifest } from "./_contract";

export const tutorWebManifest = {
	id: "tutor",
	icon: SECTION_ICONS.tutor,
	labelKey: "nav.tutor",
	tint: SECTION_TINT.tutor,
	category: SECTION_CATEGORY.tutor,
	routes: ["/tutor"],

	// Баннер РАЗГРАНИЧИВАЕТ с остальными поверхностями репетитора и объясняет
	// главное неочевидное: чат не только отвечает, но и СОЗДАЁТ артефакты в
	// приложении. Без этого он читается как «ещё один чат с ИИ».
	intro: {
		titleKey: "tutor:intro.title",
		bodyKey: "tutor:intro.body",
		bulletKeys: ["tutor:intro.bullets.0", "tutor:intro.bullets.1", "tutor:intro.bullets.2"],
	},

	nav: [
		{
			key: "tutor",
			to: "/tutor",
			icon: SECTION_ICONS.tutor,
			labelKey: "nav.tutor",
			order: 10,
		},
	],

	launch: [
		{
			key: "tutorChat",
			icon: SECTION_ICONS.tutor,
			tint: SECTION_TINT.tutor,
			titleKey: "launcher.tutorChat",
			hintKey: "launcher.tutorChatHint",
			to: "/tutor/$sessionId",
			params: { sessionId: "new" },
			order: 10,
		},
	],

	workspaceTools: [
		{
			key: "tutor",
			channel: "practice",
			// IconMessageCircle, а не эмблема раздела IconMessage2: расхождение
			// унаследовано от панели, сведение знаков — решение дизайна.
			icon: IconMessageCircle,
			steps: { 1: 70, 2: 40, 3: 20 },
		},
		{ key: "mindmap", channel: "watch", icon: IconSitemap, requiresOnline: true, steps: { 1: 30 } },
		{
			key: "infographic",
			channel: "watch",
			icon: IconChartInfographic,
			requiresOnline: true,
			steps: { 1: 40 },
		},
		{
			key: "summary",
			channel: "read",
			icon: IconTextCaption,
			requiresOnline: true,
			steps: { 1: 50 },
		},
	],
} satisfies WebModuleManifest;
